import React, { FC, useState } from 'react';
import useTranslations from '@hooks/useTranslations';

import Icon, { Icons } from '../Icon';

import { MultiSelectProps } from './index';
import { IFilterRule } from '../../redux/filters/filter.duck.interface';
import { AccessibleButton } from '@components/Button/AccessibleButton';

export const MultiSelectTemplate: FC<MultiSelectProps> = ({ className, options, handleChange: handleParentChange }) => {
    const { t } = useTranslations();

    const [isOpen, setIsOpen] = useState(false);

    const handleOpenClick = () => setIsOpen((value) => !value);

    const handleChange = (filter: any) => {
        handleParentChange(filter);
        setIsOpen(false);
    };

    const getSelectTitle = () => {
        const selectedValues = options.filter((filter) => filter.value);

        if (selectedValues.length === 0) {
            return t('filters.general.notSelectedOption');
        }

        if (selectedValues.length === 1) {
            return `${selectedValues[0].label}`;
        }

        return t('filters.general.multipleOptionsSelected', { count: selectedValues.length });
    };

    return (
        <div className={className}>
            <button
                onClick={handleOpenClick}
                className={`${isOpen ? 'is-open-extra-filter' : ''} ${
                    t('filters.general.notSelectedOption') !== getSelectTitle() ? 'hasSomeSelected' : ''
                }`}
            >
                <span className="title">{getSelectTitle()}</span>
                <Icon height={9} width={15} name={Icons.ChevronDown} />
            </button>
            {isOpen && (
                <div className="options">
                    {options.map((filter: IFilterRule) => (
                        <label key={filter.code} className="container" onClick={() => handleChange(filter)}>
                            <AccessibleButton tabIndex={isOpen ? 0 : -1}>
                                <input tabIndex={-1} type="checkbox" checked={filter.value as boolean} />
                                <span className="checkmark" />
                                <span className="label">{filter.label}</span>
                            </AccessibleButton>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};
